<template>
    <div class="match-list-container">
        <!-- <province-map-selector v-model="selectedProvinceId" @change="handleProvinceChange"
            style="margin-bottom: 20px;" /> -->
        <div class="filter-section">
            <div class="province-filter" style="padding-bottom: 15px;" v-if="provinces.length > 0">
                <el-select placeholder="请选择省份" v-model="client_region_id" @change="handleProvinceChange" filterable>

                    <el-option v-for="item in provinces" :key="item.ConstValue" :label="item.ConstShowName"
                        :value="item.ConstValue" />
                </el-select>
            </div>
            <div class="tabs-container">
                <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange">
                    <el-tab-pane label="全部" name="all"></el-tab-pane>
                    <el-tab-pane label="报名中" name="1"></el-tab-pane>
                    <el-tab-pane label="比赛进行中" name="2"></el-tab-pane>
                    <el-tab-pane label="已结束" name="3"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="search-bar">
                <el-input v-model="searchName" placeholder="请输入赛事名称" prefix-icon="el-icon-search" clearable
                    @input="handleSearch"></el-input>
            </div>
        </div>

        <div v-loading="loading" class="match-cards">

            <div v-for="(match, index) in displayedMatchList" :key="index" class="match-card"
                :class="`status-${match.MatchStatus}`">
                <div class="card-header">
                    <h3 class="match-name">{{ match.MatchName }}</h3>
                    <el-tag :type="getStatusType(match)" class="status-tag">
                        <span v-if="match.SignUpStatus != 1">{{ match.MatchStatusText }}</span>
                        <span v-if="match.SignUpStatus == 1">报名中</span>

                    </el-tag>
                </div>

                <div class="card-content">
                    <div class="info-item">
                        <i class="el-icon-date"></i>
                        <span class="info-label">报名时间:</span>
                        <span class="info-value">{{ formatDateTime(match.SignUpStartTime)
                        }}~{{ formatDateTime(match.SignUpEndTime) }}</span>
                    </div>

                    <div class="info-item">
                        <i class="el-icon-time"></i>
                        <span class="info-label">比赛时间:</span>
                        <span class="info-value">{{ formatDateTime(match.StartTime) }}~{{ formatDateTime(match.EndTime)
                        }}</span>
                    </div>

                    <div class="info-item">
                        <i class="el-icon-location"></i>
                        <span class="info-label">比赛地点:</span>
                        <span class="info-value">{{ match.MatchAddress }}</span>
                    </div>

                    <div class="info-item">
                        <i class="el-icon-user"></i>
                        <span class="info-label">报名人数:</span>
                        <span class="info-value participants">{{ match.SignUpNum }}人</span>
                    </div>
                </div>

                <div class="card-footer">
                    <el-button type="primary" size="small" @click="viewMatchDetail(match.MatchId)" round>
                        查看详情
                    </el-button>
                </div>
            </div>
            <div class="buttom-state" v-if="displayedMatchList.length > 0 && !loading">
                <p>没有更多数据了</p>
            </div>
            <div class="empty-state" v-if="displayedMatchList.length == 0 && !loading">
                <el-empty description="暂无赛事"></el-empty>
            </div>
        </div>

        <!-- <div class="pagination-container">
            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                layout="total, prev, pager, next" :total="total" background></el-pagination>
        </div> -->
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>这是一段信息</span>
            <province-map-selector v-model="selectedProvinceId" @change="handleProvinceChange"
                style="margin-bottom: 20px;" />
        </el-dialog>
    </div>

</template>

<script>
import contestantServices from "@/request-server/request-services/contestant-services.js";
import systemService from "@/request-server/request-services/system-services.js";
import provinceMapSelector from '@/components/common/province-map-selector.vue'
import { provinceList, provinceData } from '@/data/province'
export default {
    components: {
        provinceMapSelector
    },

    data() {
        return {
            dialogVisible: false,
            loading: false,
            client_region_id: '',
            matchList: [],
            filteredMatchList: [],
            searchName: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            activeTab: 'all',
            selectedProvinceId: '',
            selectedProvince: null,
            provinceList,
            // 状态映射
            statusMap: {
                1: { text: '报名中', type: 'success' },
                2: { text: '比赛中', type: 'warning' },
                3: { text: '已结束', type: 'info' }
            },
            selectedProvince: '',
            provinces: []

        }
    },
    watch: {
        selectedProvinceId(newVal) {
            if (newVal) {
                this.selectedProvince = Object.values(provinceData)
                    .find(p => p.id === newVal)
            } else {
                this.selectedProvince = null
            }
        }
    },
    computed: {
        handleProvinceChange(province) {
            console.log('地图选择省份：', province)
            this.selectedProvince = province
        },

        handleSelectChange(value) {
            console.log('下拉选择省份ID：', value)
        },
        displayedMatchList() {
            // 首先按搜索条件过滤
            let result = [...this.filteredMatchList];
            if (this.client_region_id) {
                result = result.filter(match => match.Province == this.client_region_id);
            }
            // 然后按标签状态过滤
            if (this.activeTab == '1') {
                //报名中
                result = result.filter(match => match.SignUpStatus === 1);
            } else if (this.activeTab == '2') {
                //比赛进行中
                result = result.filter(match => match.MatchStatus === 1);
            } else if (this.activeTab == '3') {
                result = result.filter(match => match.MatchStatus === 2);
            }

            return result;
        }
    },

    created() {
        this.getProvinces();
        this.getClientPlaceOfOrigin();
        this.selectMatchList();
    },

    methods: {
        openMap() {
            this.dialogVisible = true;
        },
        handleProvinceChange() {
            console.log(this.client_region_id)
        },
        selectMatchList() {
            this.loading = true;
            contestantServices.selectMatchList().then(resData => {
                console.log(resData);
                this.loading = false;
                if (resData.code == 0) {
                    this.matchList = resData.data;
                    this.handleSearch();
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        // 搜索处理
        handleSearch() {
            if (this.searchName.trim() === '') {
                this.filteredMatchList = [...this.matchList]
            } else {
                this.filteredMatchList = this.matchList.filter(item =>
                    item.MatchName.toLowerCase().includes(this.searchName.toLowerCase())
                )
            }
        },

        // 选项卡切换处理
        handleTabChange(tab, event) {

            // 选项卡变化时更新筛选结果
            // 实际筛选在计算属性displayedMatchList中处理
        },

        // 页码变更处理
        handleCurrentChange(page) {
            this.currentPage = page
            this.selectMatchList()
        },

        // 获取状态标签类型
        getStatusType(row) {
            if (row.SignUpStatus == 1) {
                return 'success'
            } else if (row.MatchStatus == 0) {
                return 'info';
            } else if (row.MatchStatus == 1) {
                return 'warning'
            } else if (row.MatchStatus == 2) {
                return 'info'
            } else {
                return 'info'
            }
        },

        getProvinces() {
            systemService.getConstantByType({ type: '省份' }).then((res) => {
                if (res.code == 0) {
                    this.provinces = res.data;
                    this.provinces.unshift({ ConstShowName: '全国', ConstantValue: '' })
                }
            });
        },
        getClientPlaceOfOrigin() {
            systemService.getClientPlaceOfOrigin().then((res) => {
                if (res.code == 0) {
                    this.client_region_id = res.data;
                }
            });
        },
        // 查看赛事详情
        viewMatchDetail(id) {
            this.$router.push('/contestant/match-sign-up/' + id);
        },

        // 格式化日期时间，移除ISO格式中的T
        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            return dateTimeStr.replace('T', ' ');
        }
    }
}
</script>

<style scoped>
.match-list-container {
    padding: 20px;
    background-color: #fff;
    width: 1400px;
    margin: 0 auto;
}

.filter-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
}

.tabs-container {
    flex: 1;
}

.search-bar {
    width: 300px;
    margin-left: 20px;
}

.match-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    max-height: calc(100vh - 220px);
    overflow: hidden;
    overflow-y: auto;
}

.match-cards::-webkit-scrollbar {
    width: 5px;
}

.match-card {
    height: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
    border-top: 5px solid #dcdfe6;
}

.match-card.status-1 {
    border-top-color: #67c23a;
}

.match-card.status-2 {
    border-top-color: #e6a23c;
}

.match-card.status-3 {
    border-top-color: #909399;
}

.match-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.09);
}

.card-header {
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
}

.match-name {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    color: #303133;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.4;
    min-height: 2.8em;
}

.status-tag {
    margin-left: 10px;
}

.card-content {
    padding: 15px 20px;
    flex: 1;
}

.info-item {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-start;
    color: #606266;
}

.info-item i {
    font-size: 16px;
    color: #909399;
    margin-right: 8px;
    width: 20px;
    text-align: center;
}

.info-label {
    font-weight: 500;
    margin-right: 5px;
    width: 70px;
}

.info-value {
    flex: 1;
    color: #333;
}

.info-value.participants {
    color: #409EFF;
    font-weight: 600;
}

.card-footer {
    padding: 10px 20px 20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #f0f0f0;
}


.buttom-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    color: #909399;
    grid-column: span 3;
    font-size: 18px;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #909399;
    grid-column: span 3;
    font-size: 18px;
}

.empty-state i {
    font-size: 60px;
    margin-bottom: 20px;
    color: #e0e0e0;
}


.pagination-container {
    text-align: center;
    margin-top: 20px;
    padding: 10px 0;
}

@media screen and (max-width: 1220px) {

    .filter-section,
    .match-cards {
        width: 100%;
    }

    .match-cards {
        grid-template-columns: repeat(2, 1fr);
    }

    .empty-state {
        grid-column: span 2;
    }
}

@media screen and (max-width: 768px) {
    .filter-section {
        flex-direction: column;
        align-items: flex-start;
    }

    .search-bar {
        width: 100%;
        margin-left: 0;
        margin-top: 15px;
    }

    .match-cards {
        grid-template-columns: 1fr;
    }

    .empty-state {
        grid-column: span 1;
    }
}
</style>